import { useEffect, useRef } from 'react';

export default function Hero() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    setTimeout(() => {
      el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 100);
  }, []);

  const scrollToSimulator = () => {
    document.getElementById('simulador')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20abstract%20financial%20background%20with%20green%20tones%2C%20geometric%20shapes%2C%20money%20coins%20floating%2C%20professional%20legal%20finance%20concept%2C%20dark%20green%20gradient%20overlay%2C%20clean%20minimalist%20style%2C%20high%20quality%20render%2C%20no%20people%2C%20elegant%20composition%20with%20soft%20light%20rays&width=1440&height=900&seq=hero001&orientation=landscape"
          alt="Restituição de Consórcio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-green-900/85 via-green-800/75 to-emerald-900/80"></div>
      </div>

      <div className="absolute top-0 right-0 w-96 h-96 bg-green-400/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-emerald-300/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

      <div ref={heroRef} className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-green-400/20 border border-green-400/40 text-green-200 text-sm font-medium px-4 py-2 rounded-full mb-6">
              <i className="ri-shield-check-line text-green-300"></i>
              Recuperação Garantida por Lei
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6">
              Você pode recuperar até{' '}
              <span className="text-green-400 text-5xl md:text-6xl lg:text-7xl">76%</span>{' '}
              do valor pago no seu consórcio!
            </h1>

            <p className="text-lg md:text-xl text-green-100/90 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Se você já pagou mais de{' '}
              <strong className="text-white">R$ 10.000</strong>, pode ter direito à
              restituição através de ação judicial.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={scrollToSimulator}
                className="bg-green-400 hover:bg-green-300 text-green-900 font-bold px-8 py-4 rounded-full text-base transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 shadow-lg shadow-green-900/30"
              >
                <i className="ri-calculator-line"></i>
                Simular meu valor agora
              </button>
              <button
                onClick={() => document.getElementById('explicativa')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-white/50 hover:border-white text-white font-semibold px-8 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                Como funciona
                <i className="ri-arrow-down-line"></i>
              </button>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-sm">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-6 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-green-400/20 rounded-full">
                  <i className="ri-bar-chart-2-line text-green-300 text-xl"></i>
                </div>
                <span className="font-semibold text-sm text-green-200">Resultados Reais</span>
              </div>
              <div className="grid grid-cols-3 gap-4 mb-5">
                {[
                  { value: 'R$ 2.5M+', label: 'Recuperados' },
                  { value: '1.200+', label: 'Clientes' },
                  { value: '98%', label: 'Sucesso' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-xl font-extrabold text-green-300">{stat.value}</div>
                    <div className="text-xs text-white/70 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
              <div className="border-t border-white/10 pt-4">
                <div className="flex items-center gap-2 text-sm text-white/80">
                  <i className="ri-map-pin-line text-green-300"></i>
                  Atendemos em todo o Brasil
                </div>
                <div className="flex items-center gap-2 text-sm text-white/80 mt-2">
                  <i className="ri-time-line text-green-300"></i>
                  Análise gratuita em 24h
                </div>
                <div className="flex items-center gap-2 text-sm text-white/80 mt-2">
                  <i className="ri-scales-3-line text-green-300"></i>
                  Especialistas jurídicos
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}
